import { render, staticRenderFns } from "./UserImage.vue?vue&type=template&id=2c872ec8&scoped=true&"
import script from "./UserImage.vue?vue&type=script&lang=ts&"
export * from "./UserImage.vue?vue&type=script&lang=ts&"
import style0 from "./UserImage.vue?vue&type=style&index=0&id=2c872ec8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c872ec8",
  null
  
)

export default component.exports